enum DisplayMode {
    Checkbox,
    Conditional,
    Date,
    Number,
    Switcher,
    Text
}

const getDisplayModeByName = (name: string): DisplayMode => {
    const namesArray = Object.keys(DisplayMode);
    var entry = namesArray.find(n => n.toLowerCase() == name.toLowerCase());
    if (entry) {
        return DisplayMode[entry];
    }
    return DisplayMode.Text;
}

export { DisplayMode, getDisplayModeByName };